// extracted by mini-css-extract-plugin
module.exports = {"popoverContent":"NftEllipsisShadowButton_popoverContent__3Bh5_"};